import BaseApiRequest from "./BaseApiRequest";
import { VAULT_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class UpdateVaultRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = [];

  url = VAULT_URL;

  constructor(request) {
    super();
    this.url = VAULT_URL + request.vaultUrl;
    this.body = request;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
